import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { useLang } from "../../lib/lang";
import { SectionHead, EASE } from "./Reveal";

export const Process = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 70%", "end 60%"] });
  const h = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <section id="process" className="relative bg-[#0D1124] border-y border-white/10">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-24 lg:py-36 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5 lg:sticky lg:top-32 self-start">
          <SectionHead eyebrow={t.processEyebrow} title={t.processTitle} testid="process-title" />
          <img src="/img/printer.webp" alt="3D printer nozzle" className="hidden lg:block w-full aspect-[4/3] object-cover rounded-[22px] border border-white/10 [clip-path:polygon(0_0,100%_0,100%_85%,85%_100%,0_100%)]" />
        </div>
        <div ref={ref} className="lg:col-span-6 lg:col-start-7 relative pl-10">
          <div className="absolute left-3 top-2 bottom-2 w-px bg-white/10" />
          <motion.div style={{ height: h }} className="absolute left-3 top-2 w-px bg-gradient-to-b from-violet-400 via-sky-400 to-[#FF2E4D]" />
          {t.steps.map((s, i) => (
            <motion.div
              key={i}
              data-testid={`process-step-${i + 1}`}
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.8, ease: EASE }}
              className="relative pb-14 last:pb-0"
            >
              <span className="absolute -left-[34px] top-1 w-4 h-4 rounded-full border-2 border-sky-300 bg-[#0D1124]" />
              <span className="font-mono text-sm text-violet-300">STEP 0{i + 1}</span>
              <h3 className="font-display text-3xl lg:text-4xl text-white mt-2 uppercase">{s.t}</h3>
              <p className="mt-3 text-slate-300 leading-relaxed max-w-md">{s.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
